import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	fileName: null,
	fileSize: null,
	duration: null,
	isPlaying: false,
	isLooping: false,
	hasEnded: false,
	fps: null,
	isMuted: false,
}

const videoFileSlice = createSlice({
	name: 'videoFile',
	initialState,
	reducers: {
		setFile: (s, { payload }) => {
			s.fileName = payload.fileName
			s.fileSize = payload.fileSize
			s.duration = null
			s.isPlaying = false
			s.hasEnded = false
		},
		setDuration: (s, { payload }) => {
			s.duration = payload
		},
		setPlaying: (s, { payload }) => {
			s.isPlaying = payload
			if (payload) s.hasEnded = false
		},
		setLooping: (s, { payload }) => {
			s.isLooping = payload
		},
		setHasEnded: (s, { payload }) => {
			s.hasEnded = payload
			if (payload) s.isPlaying = false
		},
		setFps: (s, { payload }) => {
			s.fps = payload
		},
		setMuted: (s, { payload }) => {
			s.isMuted = payload
		},
		clearFile: () => initialState,
	},
})

export const { setFile, setDuration, setPlaying, setLooping, setHasEnded, setFps, setMuted, clearFile } =
	videoFileSlice.actions

export default videoFileSlice.reducer
